import fetchApi from "../fetchApi";

export const UpdateRole = async (id, { name, description, permissions }) => {
  const body = {};
  if (name !== undefined) {
    body.name = name;
  }
  if (description !== undefined) {
    body.description = description;
  }
  if (permissions !== undefined) {
    body.permissions = permissions;
  }

  const options = {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(body),
    redirect: "follow",
  };

  return await fetchApi(`roles/${id}`, options);
};
